export const SET_CALL_ACTION = 'ROOM/CALLACTION/SET_CALL_ACTION'
